import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  OlxAttribute,
  OlxAttributePayload,
  OlxCategoryAttribute,
  OlxCategoryAttributeType,
} from '../../../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';
import { AdvertForm, AttributeForm } from '../../advert-action.interface';

@Component({
  selector: 'app-advert-attributes-editor',
  templateUrl: './advert-attributes-editor.component.html',
  styleUrl: './advert-attributes-editor.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AdvertAttributesEditorComponent implements OnChanges {
  @Input() attributes: OlxCategoryAttribute[] = [];
  @Input() advertForm!: FormGroup<AdvertForm>;
  @Input() existingValues?: OlxAttributePayload[] | OlxAttribute[];

  ngOnChanges(): void {
    this.advertForm.setControl('attributes', new FormArray<FormGroup<AttributeForm>>([]));

    if (!this.attributes?.length) return;

    const controls = this.attributes
      .filter((attr) => ![OlxCategoryAttributeType.PRICE, OlxCategoryAttributeType.SALARY].includes(attr.type))
      .map((attr) => {
        const group: AttributeForm = {
          code: new FormControl(attr.code, Validators.required),
        };

        const existing = this.existingValues?.find((v) => v.code === attr.code);

        if (attr.validation?.allow_multiple_values) {
          group.values = new FormControl<string[]>(
            existing?.values ?? [],
            attr.validation?.required ? Validators.required : [],
          );
        } else {
          const validators = [];
          if (attr.validation?.required) validators.push(Validators.required);
          if (attr.validation?.numeric && attr.validation?.min) validators.push(Validators.min(attr.validation.min));
          if (attr.validation?.numeric && attr.validation?.max)
            validators.push(Validators.max(Number(attr.validation.max)));

          group.value = new FormControl(existing?.value ?? null, validators);
        }

        return new FormGroup(group);
      });

    this.advertForm.setControl('attributes', new FormArray(controls));
  }

  protected onCheck(group: FormGroup<AttributeForm>, code: string, checked: boolean): void {
    const current = group.controls.values!.value ?? [];
    group.controls.values!.setValue(checked ? [...current, code] : current.filter((v: string) => v !== code));
    group.controls.values!.markAsTouched();
  }
}
